import { Tooltip } from "antd";
import BrokenLinkIcon from "@/assets/icons/broken_link.svg?react";
import { SectionTitle } from "../../components/SectionTitle";
import { CardLayout } from "../../components/CardLayout";
import { TablePlot } from "../../components/TablePlots";

const cardIcon = (
  <Tooltip title="All workspace filters are ignored for this card">
    <span className="inline-flex">
      <BrokenLinkIcon className="w-4 h-4 cursor-default text-[#2B4752]" />
    </span>
  </Tooltip>
);

export default function DemoSafetySection({
  data,
  isAEHome = false,
}: {
  data: any;
  isAEHome?: boolean;
}) {
  const headerExtra = isAEHome ? cardIcon : undefined;

  return (
    <div>
      {isAEHome ? null : <SectionTitle title="SAFETY" />}
      <div
        className={
          isAEHome ? "grid grid-cols-2 gap-4" : "grid grid-cols-3 gap-4"
        }
      >
        {!isAEHome && (
          <div>
            <CardLayout
              fullHeight={true}
              title="Quarterly Out of Range Labs"
              subtitle="Counts of Subjects with Low or High labs the past 3 months"
              headerExtra={headerExtra}
            >
              <div className="p-3 h-full">
                <TablePlot
                  data={[data.outOfRange]}
                  mode="counts"
                  categoriesTitle="LAB"
                  sorted={true}
                />
              </div>
            </CardLayout>
          </div>
        )}
        <div>
          <CardLayout
            fullHeight={true}
            title="Severe AEs & SAE Outcomes"
            subtitle="Outcomes for Severe AEs and SAEs for all time"
            headerExtra={headerExtra}
          >
            <div className="p-3 h-full">
              <TablePlot
                data={[data.aes]}
                mode="counts"
                categoriesTitle="OUTCOME"
                sorted={true}
              />
            </div>
          </CardLayout>
        </div>
        <div className="flex flex-col gap-4 lg:col-span-1 col-span-2">
          <CardLayout
            fullHeight={true}
            title="Doses Withdrawn, Interrupted, & Reduced"
            subtitle="Count of doses withdrawn, interrupted or reduced due to AEs"
            headerExtra={headerExtra}
          >
            <div className="p-3 h-full">
              <TablePlot
                data={[data.doseReduced]}
                mode="counts"
                categoriesTitle="ACTION"
              />
            </div>
          </CardLayout>
          <CardLayout
            fullHeight={true}
            title="Severe AEs & SAEs Related to IP"
            subtitle="Count of Severe AEs & SAEs related to IP"
            headerExtra={headerExtra}
          >
            <div className="p-3 h-full">
              <TablePlot
                data={[data.ipAES]}
                mode="counts"
                categoriesTitle="REASON"
                noTitle
              />
            </div>
          </CardLayout>
        </div>
      </div>
    </div>
  );
}
